import { render, staticRenderFns } from "./DataTableTranslator.vue?vue&type=template&id=10f39b39&scoped=true"
import script from "./DataTableTranslator.vue?vue&type=script&lang=js"
export * from "./DataTableTranslator.vue?vue&type=script&lang=js"
import style0 from "./DataTableTranslator.vue?vue&type=style&index=0&id=10f39b39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f39b39",
  null
  
)

export default component.exports